import { FC, useEffect } from 'react';
import proximaNovaEot from './font/Proxima-Nova-Regular.eot';
import proximaNovaWoff from './font/Proxima-Nova-Regular.woff';
import proximaNovaWoff2 from './font/Proxima-Nova-Regular.woff2';
import proximaNovaThinEot from './font/Proxima-Nova-Thin.eot';
import proximaNovaThinWoff from './font/Proxima-Nova-Thin.woff';
import proximaNovaThinWoff2 from './font/Proxima-Nova-Thin.woff2';
import proximaNovaLightEot from './font/Proxima-Nova-Light.eot';
import proximaNovaLightWoff from './font/Proxima-Nova-Light.woff';
import proximaNovaLightWoff2 from './font/Proxima-Nova-Light.woff2';
import proximaNovaSemiboldEot from './font/Proxima-Nova-Semibold.eot';
import proximaNovaSemiboldWoff from './font/Proxima-Nova-Semibold.woff';
import proximaNovaSemiboldWoff2 from './font/Proxima-Nova-Semibold.woff2';
import proximaNovaBoldEot from './font/Proxima-Nova-Bold.eot';
import proximaNovaBoldWoff from './font/Proxima-Nova-Bold.woff';
import proximaNovaBoldWoff2 from './font/Proxima-Nova-Bold.woff2';
import proximaNovaItalicEot from './font/Proxima-Nova-Regular-Italic.eot';
import proximaNovaItalicWoff from './font/Proxima-Nova-Regular-Italic.woff';
import proximaNovaItalicWoff2 from './font/Proxima-Nova-Regular-Italic.woff2';
import proximaNovaThinItalicEot from './font/Proxima-Nova-Thin-Italic.eot';
import proximaNovaThinItalicWoff from './font/Proxima-Nova-Thin-Italic.woff';
import proximaNovaThinItalicWoff2 from './font/Proxima-Nova-Thin-Italic.woff2';
import proximaNovaLightItalicEot from './font/Proxima-Nova-Light-Italic.eot';
import proximaNovaLightItalicWoff from './font/Proxima-Nova-Light-Italic.woff';
import proximaNovaLightItalicWoff2 from './font/Proxima-Nova-Light-Italic.woff2';
import proximaNovaSemiboldItalicEot from './font/Proxima-Nova-Semibold-Italic.eot';
import proximaNovaSemiboldItalicWoff from './font/Proxima-Nova-Semibold-Italic.woff';
import proximaNovaSemiboldItalicWoff2 from './font/Proxima-Nova-Semibold-Italic.woff2';
import proximaNovaBoldItalicEot from './font/Proxima-Nova-Bold-Italic.eot';
import proximaNovaBoldItalicWoff from './font/Proxima-Nova-Bold-Italic.woff';
import proximaNovaBoldItalicWoff2 from './font/Proxima-Nova-Bold-Italic.woff2';

export const ProximaNovaFont: FC = () => {
  useEffect(() => {
    if (document.querySelector('style[data-tombac-style="proxima-nova"]'))
      return;

    const styleElement = document.createElement('style');
    styleElement.setAttribute('data-tombac-style', 'proxima-nova');
    styleElement.innerHTML = `@font-face {
      font-family: 'Proxima Nova';
      font-style: normal;
      font-weight: 100;
      src: url(${proximaNovaThinEot});
      src: url(${proximaNovaThinEot}?#iefix) format('embedded-opentype'),
        url(${proximaNovaThinWoff2}) format("woff2"),
        url(${proximaNovaThinWoff}) format("woff");
    }
    @font-face {
      font-family: 'Proxima Nova';
      font-style: italic;
      font-weight: 100;
      src: url(${proximaNovaThinItalicEot});
      src: url(${proximaNovaThinItalicEot}?#iefix) format('embedded-opentype'),
        url(${proximaNovaThinItalicWoff2}) format("woff2"),
        url(${proximaNovaThinItalicWoff}) format("woff");
    }
    @font-face {
      font-family: 'Proxima Nova';
      font-style: normal;
      font-weight: 300;
      src: url(${proximaNovaLightEot});
      src: url(${proximaNovaLightEot}?#iefix) format('embedded-opentype'),
        url(${proximaNovaLightWoff2}) format("woff2"),
        url(${proximaNovaLightWoff}) format("woff");
    }
    @font-face {
      font-family: 'Proxima Nova';
      font-style: italic;
      font-weight: 300;
      src: url(${proximaNovaLightItalicEot});
      src: url(${proximaNovaLightItalicEot}?#iefix) format('embedded-opentype'),
        url(${proximaNovaLightItalicWoff2}) format("woff2"),
        url(${proximaNovaLightItalicWoff}) format("woff");
    }
    @font-face {
      font-family: 'Proxima Nova';
      font-style: normal;
      font-weight: 400;
      src: url(${proximaNovaEot});
      src: url(${proximaNovaEot}?#iefix) format('embedded-opentype'),
        url(${proximaNovaWoff2}) format("woff2"),
        url(${proximaNovaWoff}) format("woff");
    }
    @font-face {
      font-family: 'Proxima Nova';
      font-style: italic;
      font-weight: 400;
      src: url(${proximaNovaItalicEot});
      src: url(${proximaNovaItalicEot}?#iefix) format('embedded-opentype'),
        url(${proximaNovaItalicWoff2}) format("woff2"),
        url(${proximaNovaItalicWoff}) format("woff");
    }
    @font-face {
      font-family: 'Proxima Nova';
      font-style: normal;
      font-weight: 500;
      src: url(${proximaNovaSemiboldEot});
      src: url(${proximaNovaSemiboldEot}?#iefix) format('embedded-opentype'),
        url(${proximaNovaSemiboldWoff2}) format("woff2"),
        url(${proximaNovaSemiboldWoff}) format("woff");
    }
    @font-face {
      font-family: 'Proxima Nova';
      font-style: italic;
      font-weight: 500;
      src: url(${proximaNovaSemiboldItalicEot});
      src: url(${proximaNovaSemiboldItalicEot}?#iefix) format('embedded-opentype'),
        url(${proximaNovaSemiboldItalicWoff2}) format("woff2"),
        url(${proximaNovaSemiboldItalicWoff}) format("woff");
    }
    @font-face {
      font-family: 'Proxima Nova';
      font-style: normal;
      font-weight: 700;
      src: url(${proximaNovaBoldEot});
      src: url(${proximaNovaBoldEot}?#iefix) format('embedded-opentype'),
        url(${proximaNovaBoldWoff2}) format("woff2"),
        url(${proximaNovaBoldWoff}) format("woff");
    }
    @font-face {
      font-family: 'Proxima Nova';
      font-style: italic;
      font-weight: 700;
      src: url(${proximaNovaBoldItalicEot});
      src: url(${proximaNovaBoldItalicEot}?#iefix) format('embedded-opentype'),
        url(${proximaNovaBoldItalicWoff2}) format("woff2"),
        url(${proximaNovaBoldItalicWoff}) format("woff");
    }
    `;

    document.head.appendChild(styleElement);
  }, []);

  return null;
};
